export const translationsParkingTilda = {
  'tilda_parkings_cutouts--title': 'Kein Parken (Stanzungen) [TILDA]',
  'tilda_parkings_cutouts-access--key': 'Zugang',
  'tilda_parkings_cutouts-authentication_disc--key': 'Parkscheibe',
  'tilda_parkings_cutouts-capacity_confidence--key': 'Kapazität Vertrauen',
  'tilda_parkings_cutouts-capacity_source--key': 'Kapazität Quelle',
  'tilda_parkings_cutouts-capacity--key': 'Kapazität',
  'tilda_parkings_cutouts-charge--key': 'Ladestation',
  'tilda_parkings_cutouts-condition_category--key': 'Parkbeschränkung',
  'tilda_parkings_cutouts-condition_vehicles--key': 'Fahrzeugbeschränkungen',
  'tilda_parkings_cutouts-direction--key': 'Richtung',
  'tilda_parkings_cutouts-disabled--key': 'Behindertenparkplatz',
  'tilda_parkings_cutouts-fee--key': 'Gebühr',
  'tilda_parkings_cutouts-hgv--key': 'Lkw',
  'tilda_parkings_cutouts-markings--key': 'Markierungen',
  'tilda_parkings_cutouts-maxstay_motorhome--key': 'Maximale Parkdauer Wohnmobil',
  'tilda_parkings_cutouts-maxstay--key': 'Maximale Parkdauer',
  'tilda_parkings_cutouts-motorcar--key': 'Pkw',
  'tilda_parkings_cutouts-name--key': 'Straßenname',
  'tilda_parkings_cutouts-operator_type--key': 'Betreibertyp',
  'tilda_parkings_cutouts-orientation--key': 'Ausrichtung',
  'tilda_parkings_cutouts-parking--key': 'Parken',
  'tilda_parkings_cutouts-private--key': 'Privat',
  'tilda_parkings_cutouts-reason--key': 'Grund',
  'tilda_parkings_cutouts-restriction_bus--key': 'Bus Beschränkung',
  'tilda_parkings_cutouts-restriction_hgv--key': 'LKW Beschränkung',
  'tilda_parkings_cutouts-restriction_reason--key': 'Beschränkung Grund',
  'tilda_parkings_cutouts-restriction--key': 'Beschränkung',
  'tilda_parkings_cutouts-road_width_confidence--key': 'Straßenbreite Vertrauen',
  'tilda_parkings_cutouts-road_width_source--key': 'Straßenbreite Quelle',
  'tilda_parkings_cutouts-road_width--key': 'Straßenbreite',
  'tilda_parkings_cutouts-road--key': 'Straßentyp',
  'tilda_parkings_cutouts-staggered--key': 'Versetzt',
  'tilda_parkings_cutouts-taxi--key': 'Taxi',
  'tilda_parkings_cutouts-zone--key': 'Zone',
  'tilda_parkings_no--title': 'Kein Parken [TILDA]',
  'tilda_parkings_separate--title': 'Parken (separate Flächen) [TILDA]',
  'tilda_parkings--title': 'Parken [TILDA]',
}
